import { render, staticRenderFns } from "./BuyAlbumModal.vue?vue&type=template&id=799a2ad6"
import script from "./BuyAlbumModal.vue?vue&type=script&lang=js"
export * from "./BuyAlbumModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports